import { AuthApi } from './methods/AuthApi';
import { BodyDimensionsLogApi } from './methods/BodyDimensionsLogApi';
import { MenuApi } from './methods/MenuApi';
import { MenuCatalogApi } from './methods/MenuCatalogApi';
import { PhotoLogApi } from './methods/PhotoLogApi';
import { StepsLogApi } from './methods/StepsLogApi';
import { TargetsApi } from './methods/TargetsApi';
import { WeightLogApi } from './methods/WeightLogApi';
import { ZeppApi } from './methods/ZeppApi';

import { IHttpTransport } from '@interfaces';

export class Api {

	static transport: IHttpTransport;

	static auth = new AuthApi(Api);
	static targets = new TargetsApi(Api);
	static weightLog = new WeightLogApi(Api);
	static stepsLog = new StepsLogApi(Api);
	static bodyDimensionsLog = new BodyDimensionsLogApi(Api);
	static photoLog = new PhotoLogApi(Api);
	static menu = new MenuApi(Api);
	static menuCatalog = new MenuCatalogApi(Api);
	static zepp = new ZeppApi(Api);

	static setTransport(transport: IHttpTransport) {
		this.transport = transport;
	}

	static getTransport(): IHttpTransport {
		return this.transport;
	}

}
